// From: https://medium.com/nerd-for-tech/how-to-combine-context-providers-for-cleaner-react-code-9ed24f20225e
import React from 'react'

// Takes an array of Components (providers in our case)
// such as [C1, C2, ... , Cn] and returns a wrapping component:
// <C1>
//   <C2>
//     ...
//     <Cn>{children}</Cn>
//     ...
//   </C2>
// </C1>
const combineComponents = (...components) => {
  // Build up wrapping component from right to left
  return components.reduce(
    (CompAcc, CompCurr) => {
      return ({ children }) => {
        return (
          <CompAcc>
            <CompCurr>{children}</CompCurr>
          </CompAcc>
        )
      }
    },
    ({ children }) => <>{children}</> // Innermost component
  )
}

export default combineComponents
